import { globalSearchReq } from "../../../redux/guest-slices/common.slice";
import TablePagination from "../../../components/common/TablePagination";
import { Fragment, lazy, Suspense, useEffect, useState } from "react";
import SectionSkeleton from "../../../components/ui/SectionSkeleton";
import SkeletonImage from "../../../components/ui/SkeletonImage";
import { FILE_PATH_URI } from "../../../utils/helper";
import { useDispatch, useSelector } from "react-redux";
import { Link as NavLink } from "react-router-dom";
import { useSearchParams } from "react-router-dom";
import Images from "../../../assets/js/Images";
import moment from "moment";

import {
  Alert, Box, Button, Container, Divider, Grid2 as Grid,
  Link, Paper, Skeleton, Stack, Typography
} from "@mui/material";

const TopBannerA = lazy(() => import("../../../components/common/TopBannerA"));

const GlobalSearch = () => {
  const dispatch = useDispatch();

  const [data, setData] = useState({});
  const { loadings } = useSelector((state) => state.otherSlice);

  const [searchParams] = useSearchParams();
  const searchQuery = searchParams.get("search") || "";
  const handleRetrieveAll = async (filters) => {
    const response = await dispatch(
      globalSearchReq({
        limit: 10,
        type: "upcoming",

        currentPage: filters?.currentPage || null,
        search: searchQuery || null,
      })
    ).unwrap();
    setData(response);
  };

  const getDetailRoute = (item) => {
    switch (item?.type) {
      case "blog":
        return `/blog/${item?._id}`;
      case "forum":
        return `/forum/${item?._id}`;
      case "webinar":
        return `/webinar/${item?._id}`;
      default:
        return "/";
    }
  };

  const getCategoryRoute = (item) => {
    switch (item?.type) {
      case "blog":
        return `/blog-category/${item?.category?._id}`;
      case "forum":
        return `/forum-category/${item?.category?._id}`;
      case "webinar":
        return `/webinar-category/${item?.category?._id}`;
      default:
        return "/";
    }
  };

  useEffect(() => {
    handleRetrieveAll();
    // eslint-disable-next-line
  }, [searchQuery]);
  return (
    <Fragment>
      <Suspense fallback={<SectionSkeleton />}>
        <TopBannerA
          heading="Search result"
          bannerImg={Images?.search}
          currentPage="Search"
        />
      </Suspense>

      <Box sx={{ py: { xs: 5, lg: 10 }, bgcolor: "#f1f1f1" }}>
        <Container maxWidth={false} fixed>
          <Grid container spacing={5} sx={{ height: "100%" }}>
            {loadings?.retrieveAll ? (
              new Array(4).fill().map((_, i) => (
                <Grid key={i} size={{ xs: 12, md: 6, lg: 4 }}>
                  <Skeleton
                    sx={{
                      width: "100%",
                      transform: "none",
                      aspectRatio: "1/0.5",
                    }}
                  />
                </Grid>
              ))
            ) : data?.records?.length === 0 ? (
              <Grid size={12}>
                <Alert
                  sx={{
                    fontSize: "20px",
                    fontWeight: "500",
                    alignItems: "center",
                    fontFamily: "Poppins",
                    ".MuiAlert-message": { p: "0" },
                    ".MuiAlert-icon": { fontSize: "28px" },
                  }}
                  color="error"
                  severity="error"
                >
                  No Records Found!
                </Alert>
              </Grid>
            ) : (
              data?.records?.map((element, i) => (
                <Grid key={i} size={{ xs: 12, md: 6, lg: 4 }}>
                  <Paper
                    sx={{
                      p: 2,
                      gap: 1,
                      height: "100%",
                      display: "flex",
                      borderRadius: "6px",
                      border: "1px solid",
                      borderColor: "divider",
                      flexDirection: "column",
                      transition: "all 450ms ease",
                      boxShadow: "0 0 10px 0 #0000000a",
                      ":hover": {
                        transform: "scale(1.01)",
                        boxShadow: "0 0 10px 0 #00000021",
                      },
                    }}
                  >
                    <Box
                      sx={{
                        width: "100%",
                        overflow: "hidden",
                        borderRadius: "6px",
                        aspectRatio: "1/0.6",
                      }}
                    >
                      <Link to={getDetailRoute(element)} component={NavLink}>
                        <SkeletonImage
                          src={FILE_PATH_URI + element?.image?.path}
                        />
                      </Link>
                    </Box>

                    <Stack spacing={2} sx={{ flexGrow: 1 }}>
                      <Divider />
                      {element?.category && (
                        <Button
                          sx={{
                            minWidth: "120px",
                            width: "fit-content",
                            justifyContent: "center",
                            textTransform: "uppercase",
                            transition: "all 350ms ease",
                            ":hover": {
                              color: "white",
                              bgcolor: "secondary.dark",
                            },
                          }}
                          size="small"
                          color="secondary"
                          variant="outlined"
                          LinkComponent={NavLink}
                          to={getCategoryRoute(element)}
                        >
                          {element?.category?.name}
                        </Button>
                      )}

                      <Link
                        sx={{
                          width: "100%",
                          overflow: "hidden",
                          WebkitLineClamp: 1,
                          color: "other.color1",
                          display: "-webkit-box",
                          // WebkitBoxOrient: "vertical",
                          wordBreak: "break-word",
                          overflowWrap: "break-word",
                          whiteSpace: "pre-wrap",
                          transition: "all 350ms ease",
                          ":hover": {
                            color: "primary.main",
                          },
                        }}
                        fontSize={20}
                        fontWeight="500"
                        underline="hover"
                        to={getDetailRoute(element)}
                        component={NavLink}
                      >
                        {element?.title}
                      </Link>
                      <Box
                        sx={{
                          overflow: "hidden",
                          WebkitLineClamp: "2",
                          display: "-webkit-box",
                          textOverflow: "ellipsis",
                          WebkitBoxOrient: "vertical",
                        }}
                        dangerouslySetInnerHTML={{
                          __html: element?.description,
                        }}
                      />
                    </Stack>

                    <Box sx={{ mt: "0" }}>
                      <Typography
                        mt="auto !important"
                        lineHeight="1"
                        fontWeight="500"
                        component="span"
                        color="other.color2"
                      >
                        {element?.type === "webinar"
                          ? moment(element?.schedule?.startTime).format(
                            "MMM DD YYYY "
                          )
                          : moment(element?.createdAt).format("MMM DD YYYY")}
                      </Typography>
                      <Typography
                        sx={{ float: "right" }}
                        lineHeight="1"
                        fontWeight="600"
                        component="span"
                        color="primary.main"
                        textTransform="capitalize"
                      >
                        {element?.type}
                      </Typography>
                    </Box>
                  </Paper>
                </Grid>
              ))
            )}
          </Grid>

          <TablePagination
            pagination={data?.pagination}
            length={data?.records?.length}
            loading={loadings?.retrieveAll}
            cb={handleRetrieveAll}
          />
        </Container>
      </Box>
    </Fragment>
  );
};

export default GlobalSearch;
